class PageDown {
    constructor(el) {
        el.addEventListener('click', e => {
            e.preventDefault()
            window.scrollTo({
                top: window.innerHeight,
                behavior: 'smooth'
            })
        })
    }
}

export default PageDown


// WEBPACK FOOTER //
// ./js/classes/page-down.class.js